const accountConnectionOptions: { [key: string]: string } = {
  Manual: 'I will provide the required Bank Account details',
  Paylink: 'I would like to request the Bank Account details from my Contact',
};

export default accountConnectionOptions;
